module.exports = __webpack_public_path__ + "media/images/Arrow-forward-fill-51af6c7a.svg";